module.exports = __webpack_public_path__ + "img/home-3.b2d881ef.webp";